import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const vikunja = defineConnector({
  identifier: "vikunja",
  name: "Vikunja",
  tagLine: "Open-source task management",
  logo,
  protocol: "http",
  tags: ["productivity"],
  auth: (app) => bearerAuth(app.secret.apiToken),
  steps: [
    {
      title: "Get your API token",
      items: [
        {
          kind: "markdown",
          content:
            "In Vikunja, go to **Settings → API Tokens** and create a new token.",
        },
      ],
    },
    {
      title: "Enter your Vikunja details",
      items: [
        {
          kind: "baseUrl",
          label: "Vikunja instance URL",
          required: true,
          placeholder: "https://vikunja.example.com",
          target: { kind: "configuration", field: "instanceUrl" },
          helperText: "The base URL of your Vikunja instance.",
        },
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
        },
      ],
    },
  ],
  defaultUrlPattern: ({ instanceUrl }) => domainToRegex(instanceUrl),
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) => `${instanceUrl}/api/v1/user`,
  },
});
